// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1oIbo","actions":"GroupTable_actions__rmH6d","deleteModalFooter":"GroupTable_deleteModalFooter__1Negy"};